export const options = {
  annotations: {
    yaxis: [{
      y: 0,
      borderColor: '#f44336',
      label: {
        borderColor: '#f44336',
        style: {
          color: '#fff',
          background: '#f44336',
        },
        text: 'Support',
      }
    },{
      y: 0,
      borderColor: '#f44336',
      label: {
        borderColor: '#f44336',
        style: {
          color: '#fff',
          background: '#f44336',
        },
        text: 'Support',
      }
    }],
  },
  chart: {
    height: 380,
    type: 'line',
    id: 'areachart-2'
  },
  dataLabels: {
    enabled: true
  },
  stroke: {
    curve: 'straight'
  },
  series: [{
    name: '',
    data: [5, 10, 15]
  }],
  title: {
    text: 'Line with Annotations',
    align: 'left'
  },
  tooltip:{
    y:{
      formatter: (val) => val
    }
  },
  labels: [],
  yaxis:{
    labels:{
      formatter: function(){}
    },
    min: 0,
    max: 0
  },
  xaxis: {
    categories: [],
    labels:{
      formatter: (val) => {
        let arr = val.split(" ")
        let dateArr = arr[0].split("/")
        let aux = ''
        switch(Number(dateArr[1])){
          case 1: aux = `${dateArr[0]} Ene`; break;
          case 2: aux = `${dateArr[0]} Feb`; break;
          case 3: aux = `${dateArr[0]} Mar`; break;
          case 4: aux = `${dateArr[0]} Abr`; break;
          case 5: aux = `${dateArr[0]} May`; break;
          case 6: aux = `${dateArr[0]} Jun`; break;
          case 7: aux = `${dateArr[0]} Jul`; break;
          case 8: aux = `${dateArr[0]} Ago`; break;
          case 9: aux = `${dateArr[0]} Set`; break;
          case 10: aux = `${dateArr[0]} Oct`; break;
          case 11: aux = `${dateArr[0]} Nov`; break;
          case 12: aux = `${dateArr[0]} Dic`; break;
        }
        return aux
      }
    }
  },
}

export default options;



// WEBPACK FOOTER //
// ./src/helper/range-chart-data.js